import moment from 'moment';
import id from 'moment/locale/id';

const Date = (props) => {
  const { value } = props;
  return moment(value).locale('id').format("D MMMM YYYY");
}

export default Date;